import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { SplitButton } from 'primereact/splitbutton';
import { MenuItem } from 'primereact/menuitem';

import { ConfirmDialogService, FormatDisplay, ToastService, useForm } from '@iamsoftware/react-hooks';
import { DocumentSignService } from "../../service/DocumentSignService";
import { AgreementService, AgreementService as Service } from 'src/service/AgreementService';
import { AppStorage } from '../../service/UserStorage';
import { Oauth2GoogleService } from '../../app/hop-dong/mau-hop-dong/Oauth2GoogleService';
import { AuthService } from '../../service/AuthService';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { ScrollPanel } from 'primereact/scrollpanel';

GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.min.mjs';

export const Detail = ({ display, setDisplay, setRefresh, signingSecretCode, setSigningSecretCode }) => {
  const [data, setData] = useState(null)
  const [headerInfo, setHeaderInfo] = useState(null)
  const [displayDetail, setDisplayDetail] = useState(false)
  const [displayCode, setDisplayCode] = useState(null)
  const [reload, setReload] = useState(null)
  const [mainFiles, setMainFiles] = useState([])
  const [attachmentFiles, setAttachmentFiles] = useState([])
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [viewingAttachmentIndex, setViewingAttachmentIndex] = useState(null)
  const openedFileIdsRef = useRef<Set<string>>(new Set())
  const [mainFileReady, setMainFileReady] = useState<{ [key: string]: boolean }>({})
  const [attachmentFileReady, setAttachmentFileReady] = useState<{ [key: string]: boolean }>({})
  const [openingFileIds, setOpeningFileIds] = useState<Set<string>>(new Set())
  const [mainFileBlobUrls, setMainFileBlobUrls] = useState<{ [key: string]: string }>({})
  const [attachmentFileBlobUrls, setAttachmentFileBlobUrls] = useState<{ [key: string]: string }>({})
  const mainFileBlobUrlsRef = useRef<{ [key: string]: string }>({})
  const attachmentFileBlobUrlsRef = useRef<{ [key: string]: string }>({})

  const [mainFileCanvases, setMainFileCanvases] = useState<{ [key: string]: HTMLCanvasElement[] }>({})
  const [attachmentFileCanvases, setAttachmentFileCanvases] = useState<{ [key: string]: HTMLCanvasElement[] }>({})
  const [canvasLoading, setCanvasLoading] = useState<boolean>(false)

  const [activeMainIndex, setActiveMainIndex] = useState(0)
  const [activeAttachmentIndex, setActiveAttachmentIndex] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const ensureToken = async () => {
    try {
      const res = await AuthService.getToken();
      if (res?.moquiSessionToken) {
        AppStorage.set('moquiSessionToken', res.moquiSessionToken);
      }
    } catch (e) {
      // ignore token errors, will rely on existing session if any
    }
  };
  useEffect(() => {
    if (display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      Service.getHeaderInfo(display).then(data => {
        setHeaderInfo(data)
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || [])
        setAttachmentFiles(data?.attachmentFiles || [])
        infoForm.setValue(data)
      }).catch(error => {
      })
      setData(display)
    }
  }, [display]);


  useEffect(() => {
    if (reload && display && display !== false && display !== 'false' && display !== null && display !== 'null') {
      Service.getHeaderInfo(display).then(data => {
        setHeaderInfo(data)
        if (data?.agreementDate) {
          data.agreementDate = FormatDisplay.date(new Date(data.agreementDate), 'YYYY-MM-DD');
        }
        // Lưu danh sách files
        setMainFiles(data?.mainFiles || [])
        setAttachmentFiles(data?.attachmentFiles || [])
        infoForm.setValue(data)
      }).catch(error => {
      })
    }
  }, [reload]);

  const agreementId = headerInfo?.agreementId || data?.agreementId;

  const renderPage = (pdf: any, pageNumber: number) => {
    return pdf.getPage(pageNumber).then((page: any) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      return page.render(renderContext).promise.then(() => canvas);
    });
  };

  const loadPDFToCanvas = async (arrayBuffer: ArrayBuffer, cacheKey: string, type: 'main' | 'attachment') => {
    setCanvasLoading(true);
    try {
      const loadingTask = getDocument({ data: arrayBuffer });
      const pdf = await loadingTask.promise;
      const canvasPromises = [];
      for (let i = 1; i <= pdf.numPages; i++) {
        canvasPromises.push(renderPage(pdf, i));
      }
      const canvases = await Promise.all(canvasPromises);
      if (type === 'main') {
        setMainFileCanvases(prev => ({ ...prev, [cacheKey]: canvases }));
      } else {
        setAttachmentFileCanvases(prev => ({ ...prev, [cacheKey]: canvases }));
      }
    } catch (err) {
      console.error('Error rendering PDF to canvas:', err);
      ToastService.error('Lỗi khi hiển thị file');
    } finally {
      setCanvasLoading(false);
    }
  };

  useEffect(() => {
    if (!agreementId) return;

    const loadFilesByType = async (files: any[], type: 'main' | 'attachment') => {
      for (const file of files) {
        const fileId = file?.fileId || file?.description;
        const isGoogleFile = file?.contentLocationTypeEnumId === 'CntLocGoogleDrive';
        const index = files.indexOf(file);
        const cacheKey = `${type}_${fileId || file.agreementContentId || index}`;

        // Check if already ready or loading
        const isReady = type === 'main' ? mainFileReady[cacheKey] : attachmentFileReady[cacheKey];
        if (isReady) continue;

        try {
          let arrayBuffer: ArrayBuffer | null = null;

          if (isGoogleFile && fileId) {
            await ensureToken();
            if (!openedFileIdsRef.current.has(fileId)) {
              await AgreementService.openContent(agreementId, fileId);
              openedFileIdsRef.current.add(fileId);
            }
            const blob = await Oauth2GoogleService.getPdf(fileId);
            arrayBuffer = await blob.arrayBuffer();
          } else {
            const url = getFileUrl(file);
            if (url) {
              const response = await AgreementService.axios.get(url, { responseType: 'arraybuffer' });
              arrayBuffer = response.data;
            }
          }

          if (arrayBuffer) {
            await loadPDFToCanvas(arrayBuffer, cacheKey, type);
          }

          if (type === 'main') {
            setMainFileReady(prev => ({ ...prev, [cacheKey]: true }));
          } else {
            setAttachmentFileReady(prev => ({ ...prev, [cacheKey]: true }));
          }
        } catch (err) {
          console.error(`Error loading ${type} file:`, err);
          // Mark as ready even on error to stop spinner, or handle error state
          if (type === 'main') {
            setMainFileReady(prev => ({ ...prev, [cacheKey]: true }));
          } else {
            setAttachmentFileReady(prev => ({ ...prev, [cacheKey]: true }));
          }
        }
      }
    };

    if (mainFiles.length > 0) loadFilesByType(mainFiles, 'main');
    if (attachmentFiles.length > 0) loadFilesByType(attachmentFiles, 'attachment');
  }, [mainFiles, attachmentFiles, agreementId]);

  useEffect(() => {
    return () => {
      Object.values(mainFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
      Object.values(attachmentFileBlobUrlsRef.current).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url)
        }
      })
    }
  }, [])


  const showDetail = () => {
    if (displayDetail === false) {
      setDisplayDetail(true)
    } else setDisplayDetail(false)
  }
  const signFile = async () => {
    if (signingSecretCode) {
      if (!data) {
        ToastService.error('Mã hợp đồng không hợp lệ. Vui lòng thử lại!');

        try {
          await Service.updateSigningError({
            referenceNumber: null,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }

        return;
      }

      try {
        const signResult = await DocumentSignService.sign({
          referenceNumber: data,
          signingSecretCode: signingSecretCode
        });

        if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
          const signedPdfBase64 = signResult.data.signedFilesBase64[0];
          const roleTypeId = signResult?.signatureLocationList?.[0]?.roleTypeId || signResult?.roleTypeId || 'PartyA';
          try {
            await Service.pushSignedData({
              signedBy: 'BUYER',
              base64FileData: signedPdfBase64,
              roleTypeId: roleTypeId,
              referenceNumber: data,
              signingSecretCode: signingSecretCode
            });

            ToastService.success('Ký số thành công và đã lưu file!');
            setRefresh(Date.now());
            setDisplay(false);
            AppStorage.set('reload', String(Date.now()));
            setReload(Date.now());
          } catch (pushError) {
            try {
              await Service.updateSigningError({
                referenceNumber: data,
                signingSecretCode: signingSecretCode,
                roleTypeId: roleTypeId
              });
            } catch (apiError) {
            }

            ToastService.error('Ký số thành công nhưng lưu file thất bại!');
          }
        } else {
          const roleTypeId = signResult?.signatureLocationList?.[0]?.roleTypeId || signResult?.roleTypeId || headerInfo?.roleTypeId || 'PartyA';
          try {
            await Service.updateSigningError({
              referenceNumber: data,
              signingSecretCode: signingSecretCode,
              roleTypeId: roleTypeId
            });
          } catch (apiError) {
          }
        }
      } catch (error) {
        try {
          await Service.updateSigningError({
            referenceNumber: data,
            signingSecretCode: signingSecretCode,
            roleTypeId: headerInfo?.roleTypeId || 'PartyA'
          });
        } catch (apiError) {
        }
        if (error?.response?.status === 400 || error?.message?.includes('pull-data') || error?.config?.url?.includes('pull-data')) {
          ToastService.error('Lỗi khi tải dữ liệu ký số. Vui lòng thử lại!');
        } else {
          ToastService.error('Có lỗi khi thực hiện ký số.');
        }
      }
    } else {
      setDisplayCode(Date.now());
    }
  }
  const infoForm = useForm({
    fields: [
      { field: 'agreementNo', header: 'Số hợp đồng', disabled: true, className: 'col-12' },
      { field: 'agreementDate', header: 'Ngày hợp đồng', disabled: true, InputTextProps: { type: 'date' }, className: 'col-12' },
    ]
  })

  const downloadSignTool = (arch: '64' | '32' = '64') => {
    const fileName = arch === '64'
      ? 'IAMSigningToolSetup64bit.zip'
      : 'IAMSigningToolSetup32bit.zip';
    window.open(`/iam/tool/${fileName}`);
  }

  const toolMenuItems: MenuItem[] = [
    {
      label: 'Tải tool ký 64-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('64')
    },
    {
      label: 'Tải tool ký 32-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('32')
    }
  ]
  const submitCode = () => {
    if (signingSecretCode) {
      setDisplayCode(null)
      signFile()
    } else {
      ToastService.error('Chưa nhập mã bí mật')
    }

  }
  const footer = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex justify-content-between">
        <div>
          <b className={'pt-2'} style={{ color: 'red', fontSize: '20px' }}>Trạng thái: {headerInfo?.status}</b>
        </div>
        <div>
          <div className="flex gap-2">
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <Button label='Ký hợp đồng' severity='warning' icon="pi pi-pencil" className="p-button-sm" onClick={() => signFile()}></Button>}
            {headerInfo?.statusId !== 'AGT_SIGN_COMPLETED' && <SplitButton
              label='Tải tool ký'
              severity='info'
              icon="pi pi-download"
              onClick={() => downloadSignTool('64')}
              model={toolMenuItems}
              className="p-button-sm"
              buttonClassName="p-button-sm"
              menuButtonClassName="p-button-sm"
            />}
            <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
              type="button" onClick={() => setDisplay(false)} />
          </div>
        </div>
      </div>
    </div>
  );
  const codeFooter = (
    <div className="align-items-center justify-content-between md:col-12">
      <div className="flex  flex-row-reverse">
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm"
          type="button" onClick={() => setDisplayCode(false)} />
        <Button label='Xác nhận' severity='success' icon="pi pi-check" onClick={() => submitCode()}></Button>
      </div>
    </div>
  );
  const getFileUrl = (file) => {
    if (!file) return null

    if (file?.agreementContentId) {
      return `${Service.baseURL}/${Service.entity}/contents/${file.agreementContentId}/pdf?reload=${reload}`
    }

    return null
  }


  useEffect(() => {
    return () => {
      openedFileIdsRef.current.forEach(fileId => {
        if (agreementId) {
          AgreementService.closeContent(agreementId, fileId).catch(err => {
            console.error('Error closing editor permission:', err)
          })
        }
      })
      openedFileIdsRef.current.clear()
    }
  }, [])

  const handleCloseDialog = () => {
    openedFileIdsRef.current.forEach(fileId => {
      if (agreementId) {
        AgreementService.closeContent(agreementId, fileId).catch(err => {
          console.error('Error closing editor permission:', err)
        })
      }
    })
    openedFileIdsRef.current.clear()
    setDisplay(false)
  }

  const renderDocumentViewer = (type: 'main' | 'attachment') => {
    const files = type === 'main' ? mainFiles : attachmentFiles;
    const activeIdx = type === 'main' ? activeMainIndex : activeAttachmentIndex;
    const file = files[activeIdx];
    if (!file) {
      return (
        <div className="flex align-items-center justify-content-center h-full text-white">
          <p>Không tìm thấy file hiển thị.</p>
        </div>
      );
    }

    const fileId = file?.fileId || file?.description;
    const cacheKey = `${type}_${fileId || file?.agreementContentId || activeIdx}`;
    const canvases = type === 'main' ? mainFileCanvases[cacheKey] : attachmentFileCanvases[cacheKey];
    const isReady = type === 'main' ? mainFileReady[cacheKey] : attachmentFileReady[cacheKey];

    if (!isReady || (file.contentLocationTypeEnumId === 'CntLocGoogleDrive' && !canvases)) {
      return (
        <div className="flex flex-column align-items-center justify-content-center h-full text-white gap-3">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          <p>Đang tải tài liệu...</p>
        </div>
      );
    }

    return (
      <div className="grid grid-nogutter h-full border-round-xl overflow-hidden bg-white shadow-2">
        {/* Left Sidebar - Info */}
        <div className="col-12 lg:col-3 flex flex-column border-right-1 border-300 p-3 overflow-auto bg-surface-ground">
          <h5 className="mt-0 mb-3 flex align-items-center gap-2 font-bold">
            <i className="pi pi-info-circle text-primary"></i>
            Thông tin tài liệu
          </h5>
          <div className="custom-info-form">
            {infoForm.render()}
          </div>
          {files.length > 1 && (
            <div className="mt-4">
              <h5 className="mb-2 font-bold">Danh sách file</h5>
              <div className="flex flex-column gap-2">
                {files.map((f, i) => (
                  <Button
                    key={i}
                    label={f.fileName || `File ${i + 1}`}
                    icon="pi pi-file"
                    className={`p-button-sm text-left ${activeIdx === i ? 'p-button-info' : 'p-button-text'}`}
                    onClick={() => {
                      if (type === 'main') setActiveMainIndex(i);
                      else setActiveAttachmentIndex(i);
                      setCurrentPage(1);
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Center - PDF Content */}
        <div className="col-12 lg:col-7 flex flex-column bg-surface-100 relative">
          <div className="flex align-items-center justify-content-center p-2 bg-surface-200 border-bottom-1 border-300 text-600 text-xs gap-3">
            <span>Trang: {currentPage} / {canvases?.length || 0}</span>
          </div>
          <ScrollPanel style={{ width: '100%', height: 'calc(100vh - 250px)' }}>
            <div className="flex flex-column align-items-center p-4 min-h-full justify-content-center">
              {canvases && canvases[currentPage - 1] && (
                <div className="shadow-4 bg-white">
                  <img
                    src={canvases[currentPage - 1].toDataURL()}
                    alt={`Page ${currentPage}`}
                    style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                  />
                </div>
              )}
            </div>
          </ScrollPanel>
        </div>

        {/* Right Sidebar - Thumbnails */}
        <div className="col-12 lg:col-2 flex flex-column border-left-1 border-300 bg-surface-ground p-2 overflow-auto">
          <h6 className="text-secondary text-xs font-bold uppercase mb-3 text-center tracking-wider opacity-60">Các trang</h6>
          <ScrollPanel style={{ height: 'calc(100vh - 250px)' }}>
            <div className="flex flex-column gap-3 p-2">
              {canvases?.map((canvas, i) => (
                <div
                  key={i}
                  className={`cursor-pointer transition-all border-2 border-round overflow-hidden relative ${currentPage === i + 1 ? 'border-primary shadow-2 scale-102' : 'border-transparent opacity-70 hover:opacity-100 hover:border-300'}`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  <img
                    src={canvas.toDataURL()}
                    alt={`Thumbnail ${i + 1}`}
                    style={{ width: '100%', display: 'block' }}
                  />
                  <div className="absolute bottom-0 right-0 bg-primary text-white px-1 text-9px border-round-left">
                    {i + 1}
                  </div>
                </div>
              ))}
            </div>
          </ScrollPanel>
        </div>
      </div>
    );
  };

  return (
    <Dialog header={`Chi tiết hợp đồng`} maximized={true} draggable={false} footer={footer} visible={!!display}
      position="top" onHide={() => setDisplay(false)}
    >
      <style>{`
        .custom-info-form .p-inputtext {
          font-size: 0.875rem !important;
        }
        .custom-info-form label {
          font-size: 0.75rem !important;
          margin-bottom: 0.25rem !important;
          display: block;
        }
        .tracking-wider { letter-spacing: 0.05em; }
        .text-9px { font-size: 9px; }
        .scale-102 { transform: scale(1.02); }
      `}</style>

      {data && (
        <TabView activeIndex={activeTabIndex} onTabChange={(e) => {
          setActiveTabIndex(e.index);
          setCurrentPage(1);
        }} className="h-full">
          <TabPanel header={`File chính (${mainFiles.length})`}>
            {renderDocumentViewer('main')}
          </TabPanel>

          <TabPanel header={`File đính kèm (${attachmentFiles.length})`}>
            {renderDocumentViewer('attachment')}
          </TabPanel>
        </TabView>
      )}
      <Dialog header={`Nhập mã bí mật`} draggable={false} footer={codeFooter} visible={!!displayCode} style={{ width: '30rem', height: '12rem', }} position="center" onHide={() => setDisplayCode(false)}>
        <InputText value={signingSecretCode} onChange={(e) => setSigningSecretCode(e.target.value)} />
      </Dialog>
    </Dialog>
  );
}